module.exports = __webpack_public_path__ + "media/old_images/image-promo-forest-adaa4919.jpg";